import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import CallSlotEditForm from './callSlotEditForm';
import CallTypeEditForm from './callTypeEditForm';
// import {Button, Paper, Typography} from '@material-ui/core';
function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles((theme) => {
  return {
    paper: {
      position: 'absolute',
      width: 570,
      backgroundColor: theme.palette.background.paper,
      border: '2px solid #000',
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
    },
  };
});

export default function CallModal(props) {
  const classes = useStyles();
  const [modalStyle] = React.useState(getModalStyle);
  const [open, setOpen] = React.useState(true);

  const handleClose = () => {
    props.modalClosed();
    setOpen(false);
  };
  // console.log(props.data);
  const body = (
    <div style={modalStyle} className={classes.paper}>
      {props.editing === 'slot'
        ? <CallSlotEditForm cancel={handleClose} data={props.data} /> : <CallTypeEditForm cancel={handleClose} data={props.data} />}
    </div>
  );

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        {/* {props.editing==='delete'?
        <Paper style={modalStyle} className={classes.paper}>
        <Typography variant='h6' style={{textAlign:'center'}}>Are You Sure you want to delete this slot?</Typography>
        <div style={{display:'flex',justifyContent:'space-around',width:500,marginTop:20}}>
          <Button variant="contained" color='secondary'  onClick={handleClose}> NO</Button>
          {/* <Button variant="contained" color='primary' onClick={()=>props.handleDelete(props.data)}>YES</Button> */}
        {/* </div>
        </Paper>
        :body} */}
        {body}
      </Modal>
    </div>
  );
}
